import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Select } from 'antd'
import type { ReportDimension } from '@super-mega/server/contracts/analytics'
import { useDebouncedValue } from '@/hooks/use-debounced-value.ts'
import { useTRPC } from '@/trpc/react.ts'
import { REPORT_LABELS } from './const/reports.ts'
import { reportQueryOptions } from './utils/report-query.ts'

export function ReportDimensionSelect({
  dimension,
  id,
  value,
  onChange
}: {
  dimension: ReportDimension
  id?: string
  value?: number[]
  onChange?: (value: number[]) => void
}) {
  const trpc = useTRPC()
  const [keyword, setKeyword] = useState('')
  const search = useDebouncedValue(keyword)
  const query = useQuery({
    ...trpc.analytics.options.queryOptions({ dimension, keyword: search, selectedIds: value }),
    ...reportQueryOptions
  })
  return (
    <Select
      id={id}
      mode="multiple"
      value={value}
      onChange={onChange}
      allowClear
      maxTagCount="responsive"
      placeholder={`${REPORT_LABELS[dimension]}关键词 / ID`}
      showSearch={{ filterOption: false, onSearch: setKeyword }}
      loading={query.isFetching}
      options={query.data?.map((item) => ({ value: item.id, label: `${item.name} (#${item.id})` }))}
      notFoundContent={query.isError ? query.error.message : undefined}
    />
  )
}
